export default __webpack_public_path__ + "static/month_widget-4e62de47bb1244bccd8152d1b49be137.webp";